import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';
import shortid from 'shortid';

class ActionMenuOverlay extends Component {

  /* Methods */

  handleClickOutside(event) {
    event.preventDefault();
    this.props.onClose();
  }

  /* Render */

  render() {
    const { actions, position, listButtonHandler } = this.props;
    const overlayClassnames = classNames('action-menu__overlay', {
      [`action-menu__overlay--${position}`]: position,
    });

    const actionMenuList = actions.map((action) => {
      const child = action.item || action.name;

      const itemClassNames = classNames('action-menu__item', {
        'u-text-left': !action.item,
      });

      const buttonClassNames = classNames('button button-text', {
        'action-menu__button': !action.item,
        [`${action.classname}`]: action.classname,
      });

      return (
        <li
          key={shortid.generate()}
          className={itemClassNames}
        >
          <button
            className={buttonClassNames}
            disabled={action.disabled}
            onClick={e => listButtonHandler(e, action)}
          >
            {child}
          </button>
        </li>
      );
    });

    return (
      <div className={overlayClassnames}>
        <ul className="action-menu__list">
          {actionMenuList}
        </ul>
      </div>
    );
  }
}

ActionMenuOverlay.propTypes = {
  actions: PropTypes.array,
  listButtonHandler: PropTypes.func,
  onClose: PropTypes.func,
  position: PropTypes.string,
};

export default onClickOutside(ActionMenuOverlay);



// WEBPACK FOOTER //
// ./js/components/action-menu/overlay/index.jsx